
import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import TaskCardReminderSlider from '../TaskCardReminderSlider/TaskCardReminderSlider'
import './task-card-setting-bar.css'
import MuiPickerForCardModals from '../../MuiPickerForCardModals'

const TaskCardSettingBar = ({openModal2023, setOpenModal2023}) => {
    const [finalDateFormat, setFinalDateFormat] = React.useState('')
    const [taskCardReminderSlider, setTaskCardReminderSlider] = React.useState(false)

    React.useEffect(() => {
        formatDate()
    }, [openModal2023])

    React.useEffect(() => {
        if(document.getElementById('card-modal__reminder-slider')) {
            if(taskCardReminderSlider) {
                document.getElementById('card-modal__reminder-slider').style.maxHeight = "500px" 
                document.getElementById('card-modal__reminder-slider').style.opacity = 1
            }
        }
    }, [taskCardReminderSlider])

    const closingReminderSlider = () => {
        document.getElementById('card-modal__reminder-slider').style.maxHeight = "0px"
        setTimeout(() => document.getElementById('card-modal__reminder-slider').style.opacity = 0, 250)
        setTimeout(() => setTaskCardReminderSlider(false), 300)
    }

    const formatDate = () => {
        let todaysDate = new Date(openModal2023.todoDueDate)
        let todaysMonth = todaysDate.getMonth() + 1
        let theMonth = todaysMonth < 10 ? `0${todaysMonth}` : todaysMonth
        let theDay = todaysDate.getDate() < 10 ? `0${todaysDate.getDate()}` : todaysDate.getDate()

        setFinalDateFormat(`${todaysDate.getFullYear()}-${theMonth}-${theDay}T10:00:00`)
    }

    const generateOwnerPicture = () => {
        switch(openModal2023.todoOwner) {
            case 'Bri' : return 'https://app.atharo.app/brimassie.jpg';
            case 'Courtney': return 'https://app.atharo.app/courtneymalloy.jpg';
            default: return 'https://app.atharo.app/mmalogo.png'
        }
    }

    return(
        <div className='task-card-setting-bar'>
            <TaskCardReminderSlider closingReminderSlider={closingReminderSlider} finalDateFormat={finalDateFormat} openModal2023={openModal2023} />
            <div className='task-card-setting-bar__section'>
                <img className='task-card-setting-bar__owner-img' alt='card-pic' src={generateOwnerPicture()} />
                <div className='task-card-setting-bar__owner-selector__wrapper'>
                    <p className='task-card-setting-bar__assignment-label'>Assigned to:</p>
                    <select className='task-card-setting-bar__owner-selector' value={openModal2023.todoOwner} onChange={(e) => setOpenModal2023(prev => ({...prev, todoOwner: e.target.value}))}>
                        <option default value="">Everyone</option>
                        <option value="Bri">Bri</option>
                        <option value="Courtney">Courtney</option>
                    </select>
                </div>
            </div>
            <div className='task-card-setting-bar__section'>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MuiPickerForCardModals setOpenModal2023={setOpenModal2023} openModal2023={openModal2023} label={'Date/Time Picker'} />
                </LocalizationProvider>
            </div>
            <div className='task-card-setting-bar__section'>
            <p className='task-card-setting-bar__assignment-label'>School:</p>
                <select className='task-card-setting-bar__school-selector' value={openModal2023.whichSchool} onChange={(e) => setOpenModal2023(prev => ({...prev, whichSchool: e.target.value}))}>
                    <option default value={'all'}>ALL</option>
                    <option value="mma">MMA</option>
                    <option value="lsma">LSMA</option>
                    <option value="tma">TSMA</option>
                    <option value="mor">MOR</option>
                    <option value="psma">PSMA</option>
                    <option value="tem">TEM</option>
                    <option value="den">DEN</option>
                    <option value="tul">TUL</option>
                </select>
            </div>
            <div className="task-card-setting-bar__reminder-btn" onClick={() => setTaskCardReminderSlider(true)}>Reminder Settings</div>
        </div>
    )
}
export default TaskCardSettingBar